// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_friend.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!/home/circleci/repo/node_modules/style-loader/addStyles.js")(content);
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_friend.scss", function() {
		var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_friend.scss");
		if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
		update(newContent);
	});
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./ngapp/sass/web/html/_friend.scss
// module id = 607
// module chunks = 0